import cloneDeep from "lodash/cloneDeep";
import {
  IBuyCarMenuParams,
  IMenuListParams,
  TRaceData,
} from "@Types/buyCarMenu";
import { ICommonOptions, IRaceData } from "@Types/common";
import { EBuycarType, ECountType, EPayType, ESortType } from "@Types/constants";

export function transFormRaceData(data: TRaceData[]): IRaceData[] {
  return data.map((item) => ({
    name: item.name,
    time: item.time,
    extra: item.brandName,
    type: item.type,
  }));
}

export const initData: IMenuListParams = {
  /** 厂牌ID */
  brandId: "",
  /** 车款ID */
  kindId: "",
  /** 地区ID */
  regionId: "",
  /** 价格 */
  price: "",
  /** 类型 */
  type: undefined,
  /** 排序 */
  sort: undefined,
  /** 获取对应标签的值 */
  tag: "",
  /** 分页 */
  page: "1",
  /** 每页条数 */
  limit: "30",
  /** 获取数量 */
  count: ECountType.ALL,
};

export const resetData: IMenuListParams = {
  /** 厂牌ID */
  brandId: "-1",
  /** 车款ID */
  kindId: "-1",
  /** 地区ID */
  regionId: "-1",
  /** 价格 */
  price: "-1",
  /** 类型 */
  type: undefined,
  /** 排序 */
  sort: undefined,
  /** 获取对应标签的值 */
  tag: "-1",
  /** 分页 */
  page: "1",
  /** 每页条数 */
  limit: "30",
  /** 获取数量 */
  count: ECountType.ALL,
};

/** 排序列表 */
export const sortList: ICommonOptions[] = [
  { content: "", label: "默認排序" },
  { content: "views", label: "瀏覽" },
  { content: "interactive", label: "互動" },
  { content: "date", label: "成交時間" },
];

export function filterRequestParams(data: IMenuListParams): IMenuListParams {
  let params: IMenuListParams = {
    limit: "30",
    page: data.page,
  };

  const changeDataIds = ["brandId", "kindId", "regionId", "price", "tag"];
  const notEmptyIds = ["type", "sort"];

  changeDataIds.forEach((key) => {
    if (data[key] !== initData[key] && data[key] !== resetData[key]) {
      params[key] = data[key];
    }
  });

  notEmptyIds.forEach((key) => {
    if (data[key]) {
      params[key] = data[key];
    }
  });
  return params;
}

export function isEmptyString(str) {
  if (typeof str !== "string") return true;
  if (str.length === 0) return true;
  let spaceNum = 0;
  for (let i = 0; i < str.length; i++) {
    if (str[i] === " ") {
      spaceNum++;
    }
  }

  return spaceNum === str.length;
}
export const initMenuDetails: IRadioDetail[] = [
  { name: "配備", content: "", checked: 0, placeholder: "例如：行車記錄儀" },
  { name: "保險", content: "", checked: 0, placeholder: "例如：乙式保險36K" },
  {
    name: "規費",
    content: "",
    checked: 0,
    placeholder: "例如：共2萬元（包含領牌費）",
  },
];

export const postMenuInitData: Partial<IBuyCarMenuParams> = {
  brandId: "",
  kindId: "",
  myid: "",
  date: "",
  regionId: "",
  price: "",
  netPrice: "",
  source: "",
  paymentType: undefined,
  menuDetail: cloneDeep(initMenuDetails) as any,
  entrance: "",
};

export const tipsText = (type: EBuycarType) => {
  if (type === EBuycarType.INQUIRY) {
    return "請填寫您的購車菜單，我們將分配優質業代，為您提供報價服務，個資均已加密，請放心填寫";
  }
  return "請填寫您的成交菜單，為更多買車用戶提供參考，填寫資料僅用於菜單展示，個資均已加密，請放心填寫";
};

export interface IRadioDetail {
  name: string;
  content: string;
  checked: 0 | 1;
  placeholder: string;
}
